<template>
  <div>
    <div class="goods-module">
      <p class="goods-module__title">商品列表模块</p>
      <p class="goods-module__subtitle">
        请放在最下方，此模块无须预览，提供占位即可。
      </p>
    </div>
    <div v-if="$$FormData.goods_type === 'ZN'" class="goods-preview"
         :style="{
              paddingLeft: ($$FormData.page_edge ) * 0.5 + 'px',
              paddingRight: ($$FormData.page_edge ) * 0.5 + 'px'
            }">
      <div class="goods-list" :class="[$$FormData.goods_chamfer]" v-for="(item, itemIndex) in exampleGoods" :key="itemIndex"
           :style="{ backgroundColor: $$FormData.goods_background_color, borderColor: $$FormData.goods_border_color }">
        <div class="goods-region" v-if="$$FormData.show_goods_region">
          <img v-if="$$FormData.goods_region_style === 'custom' && $$FormData.goods_region_image" class="region-img" :src="$$FormData.goods_region_image" alt="">
          <span :style="{ color: $$FormData.goods_region_color }">{{ item.goods_region }}</span>
        </div>
        <div class="goods-content">
          <div class="goods-left">
            <img :src="item.goods_image" :alt="item.goods_image">
          </div>
          <div class="goods-right">
            <div class="goods-title">
              <div class="goods-name" v-if="$$FormData.show_goods_name">
                <div v-if="$$FormData.goods_name_style === 'default'" :style="{ fontSize: ($$FormData.text_font_size ) * 0.5 + 'px', color: $$FormData.goods_name_color, fontWeight: $$FormData.text_font_weight }">{{ item.goods_name }}</div>
                <template v-if="$$FormData.goods_name_style === 'custom'">
                  <div class="letter" v-for="(name, nameIndex) in item.goods_name" :key="nameIndex"
                       :style="{ backgroundImage: `url(${$$FormData.goods_name_bg_style})`, backgroundSize: `100% 100%`}">
                    <span :style="{ fontSize: ($$FormData.text_font_size ) * 0.5 + 'px', fontWeight: $$FormData.text_font_weight, color: $$FormData.goods_name_color }">{{ name }}</span>
                  </div>
                </template>
              </div>
              <div class="goods-brief" v-if="$$FormData.show_goods_brief" :style="{ color: $$FormData.goods_brief_color }">
                <img v-if="$$FormData.goods_brief_style === 'custom'" :src="$$FormData.goods_brief_bg_style" alt="">
                {{ item.goods_brief }}
              </div>
            </div>
            <div class="goods-price" :class="[$$FormData.goods_buy_btn_style !== 9 && 'goods-price-flex']">
              <div v-if="$$FormData.show_goods_price" class="price" :style="{ fontSize: ($$FormData.price_font_size ) * 0.5 + 'px', fontWeight: $$FormData.price_font_weight, color: $$FormData.goods_price_color }">
                <span class="currency-price" :style="{ fontSize: (($$FormData.price_font_size - 10) ) * 0.5 + 'px'}">￥</span>
                <span class="money-price">{{ Number(item.goods_price).toFixed(2) }}</span>
                <span v-if="$$FormData.show_goods_original_price && item.mktprice" class="original-price">￥{{ item.mktprice }}</span>
              </div>
              <div v-if="$$FormData.show_goods_buy_btn" class="buy-btn" :class="['style-' + $$FormData.goods_buy_btn_style]">
                <i v-if="$$FormData.goods_buy_btn_style === 1" class="van-icon van-icon-cart-circle-o"></i>
                <i v-if="$$FormData.goods_buy_btn_style === 2" class="van-icon van-icon-add-o"></i>
                <i v-if="$$FormData.goods_buy_btn_style === 5" class="van-icon van-icon-add"></i>
                <i v-if="$$FormData.goods_buy_btn_style === 6" class="van-icon van-icon-shopping-cart-o"></i>
                <img v-if="$$FormData.goods_buy_btn_style === 10" class="buy-btn-image" :src="$$FormData.buy_btn_style_image" :alt="$$FormData.buy_btn_style_image">
                <button v-else-if="$$FormData.goods_buy_btn_text" class="buy-text">
                  {{ $$FormData.goods_buy_btn_text }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$$FormData.goods_type === 'ZN-X'" class="goods-preview goods-preview-new"
         :class="[$$FormData.goods_chamfer]"
         :style="{
            margin: ($$FormData.page_edge ) * 0.5 + 'px',
            backgroundColor: $$FormData.goods_background_color
          }">
      <div class="goods-list" v-for="(item, itemIndex) in exampleGoods" :key="itemIndex">
        <div class="goods-view-x">
          <div class="goods-left">
            <img :src="item.goods_image" />
          </div>
          <div class="goods-right">
            <div class="goods-title">
              <div class="goods-name u-line-2" v-if="$$FormData.show_goods_name_x">
                <span class="self u-m-r-10" v-if="$$FormData.show_goods_self">助农</span>
                <span style="vertical-align: middle;">{{ item.goods_name }}</span>
              </div>
              <div v-if="$$FormData.show_goods_brief" :class="['goods-brief', {'HideImg':!item.goods_brief}]" :style="{color: $$FormData.goods_brief_color}">
                <img v-if="$$FormData.goods_brief_style === 'custom'" :src="$$FormData.goods_brief_bg_style" mode="aspectFit" />
                {{ item.goods_brief }}
              </div>
              <div v-if="$$FormData.show_goods_brief" :class="['goods-brief', {'HideImg':!item.goods_brief}]" :style="{color: $$FormData.goods_brief_color}">
                <img v-if="$$FormData.goods_brief_style === 'custom'" :src="$$FormData.goods_brief_bg_style" mode="aspectFit" />
                {{ item.goods_brief }}
              </div>
            </div>
            <div class="goods-price" :class="[$$FormData.goods_buy_btn_style !== 9 && 'goods-price-flex']">
              <div v-if="$$FormData.show_goods_price" class="price" :style="{ fontSize: ($$FormData.price_font_size ) * 0.5 + 'px', fontWeight: $$FormData.price_font_weight, color: $$FormData.goods_price_color }">
                <span class="currency-price" :style="{ fontSize: (($$FormData.price_font_size - 10) ) * 0.5 + 'px'}">¥</span>
                <span class="money-price">{{Number(item.goods_price).toFixed(2)}}</span>
                <span v-if="$$FormData.show_goods_original_price && item.mktprice" class="original-price">￥{{ item.mktprice }}</span>
              </div>
              <div v-if="$$FormData.show_goods_buy_btn" class="buy-btn" :class="['style-' + $$FormData.goods_buy_btn_style]">
                <i v-if="$$FormData.goods_buy_btn_style === 1" class="van-icon van-icon-cart-circle-o"></i>
                <i v-if="$$FormData.goods_buy_btn_style === 2" class="van-icon van-icon-add-o"></i>
                <i v-if="$$FormData.goods_buy_btn_style === 5" class="van-icon van-icon-add"></i>
                <i v-if="$$FormData.goods_buy_btn_style === 6" class="van-icon van-icon-shopping-cart-o"></i>
                <img v-if="$$FormData.goods_buy_btn_style === 10" class="buy-btn-image" :src="$$FormData.buy_btn_style_image" :alt="$$FormData.buy_btn_style_image">
                <button v-else-if="$$FormData.goods_buy_btn_text" class="buy-text">{{ $$FormData.goods_buy_btn_text }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {uuid} from "@/utils/foundation";

export default {
  name: 'GoodsModulePreview',
  data() {
    return {
      exampleGoods: [
        {
          goods_id: uuid(),
          goods_region: '商品地址',
          goods_name: '商品名称',
          goods_brief: '商品说明',
          goods_image: require('@/assets/placeholder-image.png'),
          goods_price: 99
        },
        {
          goods_id: uuid(),
          goods_region: '商品地址',
          goods_name: '商品名称',
          goods_brief: '商品说明',
          goods_image: require('@/assets/placeholder-image.png'),
          goods_price: 99
        },
        {
          goods_id: uuid(),
          goods_region: '商品地址',
          goods_name: '商品名称',
          goods_brief: '商品说明',
          goods_image: require('@/assets/placeholder-image.png'),
          goods_price: 99
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-module {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  margin: 0 auto;
  background-color: #fff;
  overflow: hidden;

  &__title {
    font-size: 15px;
    text-align: center;
  }

  &__subtitle {
    font-size: 12px;
    color: #999999;
    margin-top: 10px;
    text-align: center;
  }
}
.goods-preview {
  margin: 10px 0;
  .goods-list {
    overflow: hidden;
    border: 1px solid;
    &.round {
      border-radius: 8px;
    }
    .goods-content {
      display: flex;
      justify-content: center;
      padding: 10px 10px;
      .goods-left {
        width: 140px;
        height: 140px;
        background: #FDF8F3;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.14);
        border-radius: 10px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .goods-right {
        flex: 1;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        .goods-name {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          margin: 1px 0 10px;
          .letter {
            width: 27px;
            height: 29px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .goods-region {
      display: flex;
      justify-content: center;
      padding: 10px 10px 0 10px;
      .region-img {
        width: 14px;
        height: 15px;
      }
      span {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        margin-left: 8px;
        line-height: 20px;
      }
    }
  }
}

.goods-preview-new {
  overflow: hidden;
  &.round {
    border-radius: 8px;
  }
  .goods-list {
    position: relative;
    border: none;
    &::after {
      position: absolute;
      bottom: 0;
      width: 200%;
      height: 200%;
      content: "";
      display: block;
      border-bottom: 1px solid #D0D0D0;
      transform: scale(0.5);
      transform-origin: left bottom;
    }
  }
  .goods-view-x {
    display: flex;
    justify-content: center;
    padding: 15px;
    .goods-left {
      width: 100px;
      height: 100px;
      border-radius: 10px;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .goods-right {
      flex: 1;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: hidden;
      .goods-name {
        margin: 1px 0 10px;
      }
    }
  }
}

.self {
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 10px;
  min-width: 30px;
  text-align: center;
  padding: 2px 4px;
  margin-right: 5px;
  background: linear-gradient(to right, #FD5632 0%, #EF0D25 100%);
}
.goods-brief {
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 10px;
    height: 10px;
    margin-left: 1px;
    margin-right: 7px;
  }
}
.goods-price {
  &.goods-price-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .price {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin: 10px 0 5px;
  }
  .currency-price {
    margin: 0 2px;
  }
  .original-price {
    color: #909399;
    text-decoration: line-through;
    vertical-align: -2px;
    font-size: 12px;
  }
}
.buy-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  .van-icon {
    color: #f84343;
    font-size: 24px;
    line-height: normal;
    box-sizing: border-box;
  }
  &.style-4 .buy-text,
  &.style-8 .buy-text {
    color: #f84343;
    border-radius: 2px;
    border: 1px solid #f84343;
    background-color: #ffffff;
  }
  &.style-7 .buy-text {
    border-radius: 2px;
  }
  &.style-8 .buy-text {
    border-radius: 24px;
  }
  &.style-9 {
    display: inline-block;
    .buy-text {
      width: 114px;
      height: 31px;
      background: linear-gradient(0deg, #E9282A 0%, #FF7165 100%);
      border-radius: 15px;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .buy-text {
    color: #ffffff;
    background-color: #f84343;
    font-size: 12px;
    height: 24px;
    line-height: normal;
    outline: none;
    border: none;
    border-radius: 24px;
    padding: 0 8px;
    box-sizing: border-box;
    transition: all ease .2s;
  }
  .buy-btn-image {
    width: 20px;
    height: 20px;
  }
}
</style>
